import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as DataUsageIcon } from "../../../assets/svg/datausage-old.svg";

const DataUsage = () => {
    const dispatch = useDispatch();
    const packageObj = useSelector((state) => state.globalReducer.packageObj);

    useEffect(() => {
        if (packageObj?.package_code !== "enterprise") {
            let obj = {
                // total_sections: 33,
                progress_config: {
                    data_usage: 1,
                },
            };
            dispatch(configure_getting_started_progress(obj));
        }
    }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                data_usage: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <DataUsageIcon className="icon_content fill_svg" />
                        <span className="content_title">Data Usage</span>
                    </div>
                    <div className="text_content">
                        <p>{`You can track your data usage in this section.  You can also see the drill down of country wise data usage. Ongoing data is data which is fetched through your queries on an ongoing basis.  Historic data consumption is reported when you run historic jobs for previous time periods.`}</p>
                        <p>The Data Usage will only be available if you are on the enterprise plan.</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    {packageObj?.package_code == "enterprise" ? (
                        <Link to="/data-usage/overview">
                            <button className="gs_link" onClick={() => configureProgress()}>
                                Explore
                            </button>
                        </Link>
                    ) : (
                        <div className="no__access__info">*Available in Enterprise package only</div>
                    )}
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/kNG5k67UKyg"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default DataUsage;
